import React from 'react';
import { withFormsy } from 'formsy-react';
import { Rating, type InputBaseComponentProps } from '@mui/material';

import Icon from '../Icon';
import BaseTextField, { type FieldProps } from './components/BaseTextField';

type RatingFieldProps = {
	/** The field max value */
	max?: number;
	/** The icon used in the rating */
	icon?: string;
	/** The icon used in the rating when the value is not selected */
	emptyIcon?: string;
} & Omit<FieldProps<number>, 'startAdornment' | 'endAdornment'>;

/** A field with rating capabilities */
function RatingField({ max = 5, ...props }: RatingFieldProps) {
	function handleChange(event) {
		const newValue = (event.target.value * 100) / max;
		if (props.beforeChange) props.beforeChange(newValue);
		props.sendChange(props.name, newValue);
		if (props.afterChange) props.afterChange(newValue);
	}

	return (
		<BaseTextField
			className={props.className}
			name={props.name}
			label={props.label}
			InputProps={{
				inputComponent: React.forwardRef<HTMLSpanElement, InputBaseComponentProps>((inputProps, ref) => (
					<span ref={ref} {...inputProps}>
						<Rating
							value={((props.value || 0) * max) / 100}
							max={max}
							icon={props.icon ? <Icon icon={props.icon} size={22} /> : undefined}
							emptyIcon={props.emptyIcon ? <Icon icon={props.emptyIcon} size={22} /> : undefined}
							readOnly={!props.isEdit}
							onChange={handleChange}
						/>
					</span>
				))
			}}
			isEdit={props.isEdit}
			required={props.required}
			errorMessage={props.errorMessage}
			isFormSubmitted={props.isFormSubmitted}
			isPristine={props.isPristine}
			isValid={props.isValid}
			logProps={props.logProps}
		/>
	);
}

export default React.memo(withFormsy(RatingField));
